import React, { useEffect, useState } from 'react';
import { Modal } from '../Modal';
import { Form, Input, Space } from 'antd';
import { FormattedMessage, useIntl } from 'react-intl';
import { useAuth } from '../../contexts/auth';
import { createNotification } from '../../components';
import { createWorkspace } from '../../services/workspace/api';

export function CreateWorkspaceModal({ open, onCancel, onSubmit }) {
  const intl = useIntl();
  const [form] = Form.useForm();
  const { setWorkspaces } = useAuth();
  const [submittable, setSubmittable] = useState(false);

  const values = Form.useWatch([], form);

  useEffect(() => {
    form
      .validateFields({
        validateOnly: true,
      })
      .then(() => setSubmittable(true))
      .catch(() => setSubmittable(false));
  }, [form, values]);

  const submit = async values => {
    await createWorkspace(values)
      .then(res => {
        createNotification(
          'success',
          intl.formatMessage({ id: 'modal.workspace.create.success' }),
        );
        setWorkspaces(res.data.workspaces);
        onSubmit();
        form.resetFields();
      })
      .catch(() => {
        createNotification(
          'error',
          intl.formatMessage({ id: 'modal.workspace.create.error' }),
        );
      });
  };

  return (
    <Modal.Root visible={open}>
      <Modal.Header
        onCancelAction={onCancel}
        title={intl.formatMessage({ id: 'modal.workspace.create.title' })}
      />
      <Modal.Content align={'start'}>
        <Space
          direction="vertical"
          size="middle"
          style={{
            display: 'flex',
          }}
        >
          <Form
            layout="vertical"
            form={form}
            onFinish={submit}
          >
            <Form.Item
              label="Workspace"
              name="name"
              rules={[
                {
                  required: true,
                  message: 'Please input the name!',
                },
                { max: 20 },
              ]}
            >
              <Input
                placeholder={intl.formatMessage({
                  id: 'modal.workspace.create.placeholder',
                })}
                required
                size="large"
              />
            </Form.Item>
          </Form>
        </Space>
      </Modal.Content>
      <Modal.Actions
        loading={false}
        disabled={!submittable}
        submitText={<FormattedMessage id={'send'} />}
        onSubmitAction={form.submit}
        onCancelAction={onCancel}
      />
    </Modal.Root>
  );
}
